import {
  isCustomerAppPath,
  isPathPrefix,
  isPublicProfilePath,
  normalizePathname,
} from '@/utils/clientPaths';
import { hostPaths } from '@/utils/hostPaths';
import type { UserRole } from '@/types/auth';

/**
 * Customer-app paths that co-hosts may open while managing a community
 * (e.g. show QRIS checkout for a participant from the host dashboard).
 */
export function isCoHostAllowedCustomerPath(pathname: string): boolean {
  const path = normalizePathname(pathname);
  return isPathPrefix(path, '/event/checkout');
}

export function shouldKickCoHostToHost(isCoHost: boolean, pathname: string): boolean {
  if (!isCoHost) return false;
  if (isCoHostAllowedCustomerPath(pathname)) return false;
  return isCustomerAppPath(pathname);
}

/**
 * Customer-app paths that community owners may open (share/deep-link / event ops),
 * without granting access to customer Home/Profil APIs (/client/*).
 */
export function isCommunityAllowedCustomerPath(pathname: string): boolean {
  const path = normalizePathname(pathname);

  if (isPathPrefix(path, '/event/checkout')) return true;

  // /event/:slug... but not list root or reserved customer-host routes
  const eventMatch = path.match(/^\/event\/([^/]+)(?:\/(.*))?$/);
  if (eventMatch) {
    const first = eventMatch[1];
    const reserved = new Set(['create', 'edit', 'checkout', 'dashboard']);
    if (reserved.has(first)) return false;
    return true;
  }

  if (isPublicProfilePath(path)) return true;

  return false;
}

export function shouldKickCommunityToHost(
  role: UserRole | string | null | undefined,
  pathname: string
): boolean {
  if (role !== 'community') return false;
  if (isCommunityAllowedCustomerPath(pathname)) return false;
  return isCustomerAppPath(pathname);
}

export function getCoHostHomePath(): string {
  return hostPaths.home;
}
